<div class="select-default">
    <label *ngIf="label!=''">{{label}}</label>
    <!-- CAREFUL: the $event.target.value propertie is from dom properties not our interfaces -->
    <select (change)="onChange($event.target.value)" [(ngModel)]="selected" [disabled]="disabled">
        <option *ngIf="placeholder && placeholder!=''" value="" disabled selected>{{placeholder}}</option>
        <ng-container *ngIf="!defaultOrder else defaultOptionsOrder">
            <option *ngFor="let opt of options | sortBy: 'description' : 'asc'; trackBy: trackByFn" [value]="opt.key" [disabled]="opt.disabled">
                {{opt.description}}
            </option>
        </ng-container>
        <ng-template #defaultOptionsOrder>
            <option *ngFor="let opt of options; trackBy: trackByFn" [value]="opt.key" [disabled]="opt.disabled">
                {{opt.description}}
            </option>
        </ng-template>
    </select>
</div>
